<script lang="ts" setup>
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'

withDefaults(
  defineProps<{
    name: string
    active?: boolean
  }>(),
  {
    active: false,
  },
)

const emit = defineEmits<{
  (event: 'cancel'): void
  (event: 'commit'): void
  (event: 'clear'): void
}>()

const visible = ref(false)

function onCancel() {
  visible.value = false
  emit('cancel')
}

function onReset() {
  visible.value = false
  emit('clear')
}

function onCommit() {
  visible.value = false
  emit('commit')
}

function onClear() {
  emit('clear')
}

const route = useRoute()
watch(route, () => {
  visible.value = false
})
</script>

<template>
  <div class="filter-group-wrapper">
    <button class="filter-group" @click="visible = !visible" :class="{ active: active }">
      <span class="filter-label">
        <img
          v-if="!active"
          src="@/assets/img/add-filter.svg"
          alt=""
          style="margin-right: 00.75ch"
          class="add-icon"
        />
        <span v-else class="icon-wrapper">
          <slot name="icon">
            <!-- prettier-ignore -->
            <svg width="20" height="20" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m195.7 54 5.5-29.4A30.1 30.1 0 0 1 231 0h50c14.5 0 27 10.3 29.7 24.6l5.5 29.3c13.9 4.2 27.3 9.7 40 16.6l24.6-16.9c12-8.1 28-6.7 38.3 3.6l35.6 35.6a30.1 30.1 0 0 1 3.6 38.3l-17 24.6a209.6 209.6 0 0 1 16.7 40l29.3 5.5A30.1 30.1 0 0 1 512 231v50c0 14.5-10.3 27-24.6 29.7l-29.3 5.5a209.6 209.6 0 0 1-16.6 40l16.9 24.6c8.1 12 6.7 28-3.6 38.3l-35.6 35.6a30.1 30.1 0 0 1-38.3 3.6l-24.6-17a209.6 209.6 0 0 1-40 16.7l-5.5 29.3A30.1 30.1 0 0 1 281 512h-50c-14.5 0-27-10.3-29.7-24.6l-5.5-29.3a209.6 209.6 0 0 1-40-16.6l-24.6 16.9c-12 8.1-28 6.7-38.3-3.6l-35.6-35.6a30.1 30.1 0 0 1-3.6-38.3l17-24.6a209.6 209.6 0 0 1-16.7-40l-29.3-5.5A30.1 30.1 0 0 1 0 281v-50c0-14.5 10.3-27 24.6-29.7l29.3-5.5c4.2-13.9 9.7-27.3 16.6-40l-16.9-24.6c-8.1-12-6.7-28 3.6-38.3l35.6-35.6a30.1 30.1 0 0 1 38.3-3.6l24.6 17a209.6 209.6 0 0 1 40-16.7Zm-33 47.2a15 15 0 0 1-16.2-.5l-32.4-22.2L78.5 114l22.2 32.4a15 15 0 0 1 .5 16.3 179.5 179.5 0 0 0-20.6 49.6 15 15 0 0 1-11.9 11.2L30.1 231v50l38.6 7.3a15 15 0 0 1 11.9 11.2 179.5 179.5 0 0 0 20.6 49.6 15 15 0 0 1-.5 16.3l-22.2 32.4 35.6 35.6 32.4-22.2a15 15 0 0 1 16.3-.5 179.5 179.5 0 0 0 49.6 20.6 15 15 0 0 1 11.2 11.9l7.3 38.6H281l7.3-38.6a15 15 0 0 1 11.2-11.9 179.5 179.5 0 0 0 49.6-20.6 15 15 0 0 1 16.3.5l32.4 22.2 35.6-35.6-22.2-32.4a15 15 0 0 1-.5-16.3 179.5 179.5 0 0 0 20.6-49.6 15 15 0 0 1 11.9-11.2l38.6-7.3v-50l-38.6-7.3a15 15 0 0 1-11.9-11.2 179.5 179.5 0 0 0-20.6-49.6 15 15 0 0 1 .5-16.3l22.2-32.4L398 78.5l-32.4 22.2a15 15 0 0 1-16.3.5 179.5 179.5 0 0 0-49.6-20.6 15 15 0 0 1-11.2-11.9L281 30.1h-50l-7.3 38.6a15 15 0 0 1-11.2 11.9 179.5 179.5 0 0 0-49.6 20.6ZM256 361.4a105.4 105.4 0 1 1 0-210.8 105.4 105.4 0 0 1 0 210.8Zm0-30.1a75.3 75.3 0 1 0 0-150.6 75.3 75.3 0 0 0 0 150.6Z"/></svg>
          </slot>
        </span>
        {{ name }}
      </span>
      <div class="summary" v-if="active">
        <slot name="summary" />
      </div>
    </button>
    <div v-if="active" class="filter-group-clear-wrapper">
      <Button icon="pi pi-times" text class="filter-group-clear" @click="onClear" />
    </div>
  </div>
  <Dialog v-model:visible="visible" modal :header="name" class="filter-dialog" :draggable="false">
    <div class="filter-controls">
      <slot name="body" />
    </div>
    <footer class="filter-dialog-footer">
      <Button
        type="button"
        label="Zurücksetzen"
        severity="secondary"
        @click="onReset"
        style="margin-right: auto"
      />
      <Button type="button" label="Abbrechen" severity="secondary" @click="onCancel" />
      <Button type="button" label="Anwenden" @click="onCommit" />
    </footer>
  </Dialog>
</template>

<style scoped lang="scss">
@use '@/styles/util' as *;

:global(.filter-dialog) {
  width: min(600px, calc(100% - 1rem));
}

:global(.filter-dialog-footer) {
  --offset: 1.5rem;
  position: sticky;
  bottom: calc(-1 * var(--offset));
  background: white;
  padding: calc(2 * var(--offset)) var(--offset) var(--offset);
  margin-bottom: calc(-1 * var(--offset));
  margin-right: calc(-1 * var(--offset));
  margin-left: calc(-1 * var(--offset));
  mask-image: linear-gradient(to bottom, #0000 0%, #000f calc(2 * var(--offset)));
}

.filter-controls {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 2.5em;
  padding: 25px 0;
  justify-content: start;
  align-items: start;

  & > * {
    max-width: 100%;
  }

  :deep(.p-float-label) {
    display: grid;
  }

  //:deep(.filter-row-2) {
  //  grid-template-columns: repeat(2, 1fr);
  //}
}

.filter-group-wrapper {
  position: relative;
}

.filter-group {
  @include form-reset;
  background-color: #fff;

  border: var(--border-style);
  border-radius: 2px;
  padding: 15px 60px 15px 20px;

  transition: border-color ease 200ms;
  line-height: 1.2;
  display: grid;

  &.active {
    border-color: #000;
  }

  &:hover {
    cursor: pointer;
    //background-color: #f9f9f9;
    border-color: var(--primary-color);
    box-shadow: var(--box-shadow);
    //background-color: var(--primary-color);
    //border-color: var(--primary-color);
    //color: white;

    .add-icon {
      transform: scale(1.15);
    }
  }

  .filter-label {
    display: flex;
    align-items: center;
    gap: 0.75ch;
    font-weight: 500;
  }

  .add-icon {
    transition: transform ease 200ms;
  }

  .icon-wrapper {
    margin-top: -0.1em;
  }

  .icon-wrapper:deep(> *) {
    display: block;
  }

  .summary {
    color: var(--light-text-color);
    font-size: 16px;
    margin-top: 0.5em;

    &:empty {
      display: none;
    }
  }

  &:focus {
    outline: none;

    &:focus-visible {
      outline: 1px solid var(--primary-color);
      outline-offset: -4px;
    }
  }
}

.filter-group-clear-wrapper {
  position: absolute;
  right: 10px;
  top: 0.6rem;
}

footer {
  display: flex;
  justify-content: flex-end;
  gap: 1ch;
}
</style>
